export default "__VITE_ASSET__Brx2Gkzq__"